import React, { useState, useEffect } from 'react';
import GlassCard from '../components/ui/Card';
import GlassButton from '../components/ui/Button';
import InputField from '../components/ui/InputField';
import CustomSelect from '../components/ui/Select';

const ClientRegistrationForm = ({ clientToEdit, onSave, onCancel }) => {
    const [clientData, setClientData] = useState({
      name: '',
      contact: '',
      status: 'Ativo'
    });

    const statusOptions = [
        { value: 'Ativo', label: 'Ativo' },
        { value: 'Inativo', label: 'Inativo' },
        { value: 'Potencial', label: 'Potencial' },
    ];

    useEffect(() => {
        if(clientToEdit) {
            setClientData({
                ...clientToEdit,
                status: clientToEdit.status || 'Ativo'
            });
        } else {
            setClientData({ name: '', contact: '', status: 'Ativo' });
        }
    }, [clientToEdit]);
    
    const handleChange = (e) => {
      const { name, value } = e.target;
      setClientData(prev => ({ ...prev, [name]: value }));
    };
    
    const handleSubmit = (e) => {
      e.preventDefault();
      onSave(clientData);
    };
    
    return (
      <div className="space-y-4">
        <h2 className="text-3xl font-bold text-white mb-4">
          {clientToEdit ? 'Editar Cliente' : 'Cadastrar Novo Cliente'}
        </h2>
        <GlassCard className="p-4 md:p-8">
          <form onSubmit={handleSubmit} className="space-y-6 text-white">
            <InputField
              label="Nome do Cliente"
              name="name"
              value={clientData.name}
              onChange={handleChange}
              required
            />
            <InputField
              label="Contato (email, telefone, etc.)"
              name="contact"
              value={clientData.contact}
              placeholder="Ex: email@dominio.com ou (xx) xxxxx-xxxx"
            />
            <CustomSelect
                label="Status"
                options={statusOptions}
                value={clientData.status}
                onChange={(e) => handleChange({ target: { name: 'status', value: e.target.value } })}
            />
            <div className="flex justify-end space-x-2 pt-4">
                <GlassButton type="button" onClick={onCancel} variant="minimal">
                    Cancelar
                </GlassButton>
                <GlassButton type="submit">
                    {clientToEdit ? 'Salvar Alterações' : 'Cadastrar Cliente'}
                </GlassButton>
            </div>
          </form>
        </GlassCard>
      </div>
    );
};

export default ClientRegistrationForm;